/* HOTSOX PROMOTION BATTLE 5 — LP scripts (no dependencies) */
(function () {
  'use strict';
  var root = document.documentElement;
  try {
  root.classList.add('hx-js');

  var PB5 = window.PB5 || {};
  var SHOP = PB5.shopUrl || '/';
  function asset(kind, f) { return (PB5.assets && PB5.assets[kind + '/' + f]) || ''; }
  var FINAL_COUNT = 11;                                  // 本戦進出チーム数（上位約半数・仮）
  var START_AT = new Date(PB5.startAt || '2026-10-16T10:00:00+09:00');  // 予選・予約販売スタート（JST）
  var SALE_AT = Date.parse('2026-11-01T10:00:00+09:00');  // 予約（決済なし）から予約時の決済へ。集計も決済済みに（2026-10-26 決定、10/27 に 10:00 へ変更）
  var onSale = function () { return Date.now() >= SALE_AT; };
  // 集計が決済済みか（pb5-api の rank.source。11/1 12:00 の集計から shopify_paid）
  var paidRank = function () { return !!RANK && RANK.source === 'shopify_paid'; };
  // いいね・ランキング API（セクション設定）。空欄 = オフライン表示（端末内だけで数える、今までどおり）
  var API = String(PB5.api || '').replace(/\s+/g, '').replace(/\/+$/, '');
  if (API && !/^https?:\/\//.test(API)) API = 'https://' + API;
  var TS_KEY = String(PB5.turnstileSiteKey || '').replace(/\s+/g, '');  // Cloudflare Turnstile サイトキー
  var RANK = null; // API モード: /v1/counts の rank（毎日12:00の集計）。null = 集計前
  var Q = location.search;

  /* ------------------------------------------------------------
     environment gates
     motionOK: prefers-reduced-motion でない
     heavyOK : さらに低スペック（Save-Data / deviceMemory<=2）でない → 粒子・ロール・FLIP・チルト
     ------------------------------------------------------------ */
  var mqSP = window.matchMedia('(max-width: 767px)');
  var mqRM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mqFine = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 768px)');
  var mqTilt = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 1024px)');
  var conn = navigator.connection || {};
  var lowSpec = !!conn.saveData || !!(navigator.deviceMemory && navigator.deviceMemory <= 2);
  function motionOK() { return !mqRM.matches; }
  function heavyOK() { return motionOK() && !lowSpec; }
  function onMQ(mq, fn) { if (mq.addEventListener) mq.addEventListener('change', fn); else mq.addListener(fn); }
  function noop() {}
  document.addEventListener('touchstart', noop, { passive: true }); // iOS で :active を有効にする
  if (navigator.share) root.classList.add('has-share');

  /* ------------------------------------------------------------
     Entry data — 2026年の21商品（画像・作品名・コンセプト・商品URL）。いいね・予約数はダミー
     kv: チームのキービジュアル（assets/img/kv/）。未着のチームは空欄 → モーダルの KEY VISUAL を出さない
     東京/大阪は混在させ、グループ分けしない（8/28 決定）
     prev = 前回更新（前日12:00）時点のダミー値。ランキングの ▲▼ 表示に使う
     ------------------------------------------------------------ */
  var ENTRIES = (PB5.entries || []).map(function (e) { return e; }); // Liquid（sections/pb5-landing.liquid）が出力
  // [予約注文の増分, いいねの増分]（現在値 − 前回値）。ダミー
  var PREV_DELTA = [[0, -3], [2, 3], [1, 8], [0, 4], [0, 61], [4, 22], [1, 2], [2, 13], [0, 7], [0, 8], [2, 9], [0, 7], [1, 3], [1, 8], [0, 9], [0, 5], [1, 6], [0, 4], [0, 3], [0, 6], [2, 10]];
  ENTRIES.forEach(function (e, i) {
    e.id = 'E' + (i + 1);
    e.no = 'TEAM ' + e.code;
    e.members = e.designer;
    var d = (PB5.demo && PREV_DELTA[i]) || [0, 0];
    e.prev = { orders: e.orders - d[0], likes: e.likes - d[1] };
    e.snap = { orders: 0, likes: 0 }; // API モード: 毎日12:00の集計（/v1/counts の rank.cur）
  });
  // デモ用 ?seed=close: いいね上位5作品を僅差にして、♡1回で順位が入れ替わる状態を作る
  if (/[?&]seed=close/.test(Q)) {
    ENTRIES.slice().sort(function (a, b) { return b.likes - a.likes; }).slice(0, 5)
      .forEach(function (e, i) { var d = e.likes - e.prev.likes; e.likes = [420, 420, 419, 419, 418][i]; e.prev.likes = e.likes - d; });
  }

  var HEART_PATH = 'M12 21s-7.5-4.6-9.6-9.1C1 8.4 3.2 4.5 7 4.5c2 0 3.4 1.1 5 2.9 1.6-1.8 3-2.9 5-2.9 3.8 0 6 3.9 4.6 7.4C19.5 16.4 12 21 12 21z';
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="hx-like__fill" d="' + HEART_PATH + '"/><path class="hx-like__line" d="' + HEART_PATH + '"/></svg>';

  /* ------------------------------------------------------------
     like state (localStorage)
     ------------------------------------------------------------ */
  var store = { likes: {}, dates: {} };
  try { var parsed = JSON.parse(localStorage.getItem('hx_pb5') || ''); if (parsed && typeof parsed === 'object') store = parsed; } catch (e) {}
  if (!store.likes || typeof store.likes !== 'object') store.likes = {};
  if (!store.dates || typeof store.dates !== 'object') store.dates = {};
  function save() { try { localStorage.setItem('hx_pb5', JSON.stringify(store)); } catch (e) {} }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function jst(t) { return new Date(t + 9 * 36e5); } // getUTC* で日本時間の値を読む
  function today() { var d = jst(Date.now()); return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()); } // 日本時間の日付（サーバーも JST 0:00 で切り替え）
  // API モードはサーバーの数だけを出す（端末内の加算 store.likes は使わない）
  function likeCount(e) { return API ? e.likes : e.likes + (store.likes[e.id] || 0); }
  // ランキングの値: API モードは毎日12:00の集計、オフラインは現在値
  function rankVal(e, k) { return API ? e.snap[k] : (k === 'likes' ? likeCount(e) : e.orders); }
  // 大きい順の比較。API モードの予約順位は、同数ならいいねの多い方が上（応援方法の注記どおり）
  function byRank(k, get) {
    return function (a, b) { return get(b, k) - get(a, k) || (API && k === 'orders' ? get(b, 'likes') - get(a, 'likes') : 0); };
  }
  function likedToday(e) { return store.dates[e.id] === today(); }
  function fmt(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function byId(id) { for (var i = 0; i < ENTRIES.length; i++) if (ENTRIES[i].id === id) return ENTRIES[i]; return null; }
  function q(el, sel) { return el.querySelector(sel); }
  function qa(el, sel) { return Array.prototype.slice.call(el.querySelectorAll(sel)); }
  function inView(el, margin) { var r = el.getBoundingClientRect(); var m = margin || 0; return r.bottom > -m && r.top < window.innerHeight + m; }

  /* ------------------------------------------------------------
     phase: 'prelim'（予選）| 'final'（本戦・デモ表示）
     ------------------------------------------------------------ */
  var phase = /[?&]phase=final/.test(Q) ? 'final' : 'prelim';
  var FINAL_IDS = [];
  function calcFinal() { FINAL_IDS = ENTRIES.slice().sort(byRank('orders', rankVal)).slice(0, FINAL_COUNT).map(function (e) { return e.id; }); }
  calcFinal(); // API モードは集計の取得後に計算し直す
  function isFinalist(e) { return FINAL_IDS.indexOf(e.id) !== -1; }
  // 一覧の並び順: 毎日12:00の集計で、前回（前日12:00）からのいいね増分が多い順（2026-10-18 決定）。
  // 累計はランキング欄のまま。集計が2回そろう前・API なし・全件0 は元の掲載順。同数も元の掲載順
  function daily(e) { return (API && RANK && RANK.prev) ? Math.max(0, e.snap.likes - e.prev.likes) : 0; }
  function dailyReady() { return ENTRIES.some(function (e) { return daily(e) > 0; }); }
  function visibleEntries(ph) {
    var list = ENTRIES.filter(function (e) { return ph !== 'final' || isFinalist(e); });
    if (dailyReady()) list.sort(function (a, b) { return daily(b) - daily(a) || ENTRIES.indexOf(a) - ENTRIES.indexOf(b); });
    return list;
  }

  /* ------------------------------------------------------------
     reveal on scroll（animation + backwards 方式。is-now = 到達済みなら即表示）
     ------------------------------------------------------------ */
  var booted = false;
  setTimeout(function () { booted = true; }, 1500);
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (ens) {
    ens.forEach(function (en) {
      if (!en.isIntersecting) return;
      var el = en.target;
      if (booted && en.intersectionRatio > 0.6) el.classList.add('is-jump');
      el.classList.add('is-in');
      io.unobserve(el);
    });
  }, { threshold: [0, 0.6], rootMargin: '0px 0px 10% 0px' }) : null;
  function observe(el) { if (io) io.observe(el); else el.classList.add('is-in'); }

  /* 行分割（<br> 区切り）: data-split */
  function splitLines(el) {
    var nodes = Array.prototype.slice.call(el.childNodes);
    var frag = document.createDocumentFragment();
    var seg = null, n = 0;
    nodes.forEach(function (node) {
      if (node.nodeType === 1 && node.tagName === 'BR' && !node.classList.contains('sp-only')) { seg = null; frag.appendChild(node); return; }
      if (!seg && node.nodeType === 3 && !node.textContent.trim()) return;
      if (!seg) {
        seg = document.createElement('span'); seg.className = 'hx-line'; seg.style.setProperty('--i', n++);
        var inner = document.createElement('span'); inner.className = 'hx-line__in'; seg.appendChild(inner);
        frag.appendChild(seg);
      }
      seg.firstChild.appendChild(node);
    });
    el.appendChild(frag);
  }
  qa(document, '[data-split]').forEach(splitLines);

  /* ------------------------------------------------------------
     entries grid
     ------------------------------------------------------------ */
  var grid = document.getElementById('grid');
  function likeLabel(e) { return e.title + ' にいいね（いいね ' + fmt(likeCount(e)) + (likedToday(e) ? '・本日応援済み' : '') + '）'; }
  function likeBtn(e) {
    var on = likedToday(e);
    return '<button class="hx-like' + (on ? ' is-on' : '') + '" type="button" data-like="' + e.id + '" aria-pressed="' + (on ? 'true' : 'false') + '" aria-label="' + likeLabel(e) + '">' + HEART +
      '<span class="hx-like__num" data-count="' + e.id + '"><span class="hx-like__n">' + fmt(likeCount(e)) + '</span></span>' +
      '<span class="hx-like__tip">今日はもう応援済み。また明日！</span></button>';
  }
  function cardHTML(e) {
    return '<article class="hx-entry" data-id="' + e.id + '">' +
      '<button class="hx-entry__img" type="button" data-open-entry="' + e.id + '" aria-label="' + e.title + ' の詳細を見る">' +
        '<img src="' + asset('entry', e.img) + '" alt="' + e.title + '" loading="lazy" decoding="async" width="720" height="960">' +
        '<span class="hx-entry__no">' + e.no + '</span>' +
        '<span class="hx-entry__zoom"><b>＋</b><span>CONCEPT / KEY VISUAL</span></span>' +
      '</button>' +
      '<div class="hx-entry__body">' +
        '<p class="hx-entry__team"><span class="hx-entry__code">' + e.no + ' ・ </span>' + e.members + '</p>' +
        '<h3 class="hx-entry__ttl">' + e.title + '</h3>' +
        '<p class="hx-entry__desc">' + e.concept + '</p>' +
        '<div class="hx-entry__act">' + likeBtn(e) +
          '<a class="hx-entry__buy" href="' + (e.url || SHOP) + '" target="_blank" rel="noopener">' + '予約する' + '</a>' +
        '</div>' +
      '</div>' +
    '</article>';
  }
  function setFinalState(card, fin) {
    card.classList.toggle('is-final', fin);
    var b = q(card, '.hx-entry__final');
    if (fin && !b) q(card, '.hx-entry__img').insertAdjacentHTML('beforeend', '<span class="hx-entry__final">FINALIST<small>本戦進出</small></span>');
    else if (!fin && b) b.parentNode.removeChild(b);
  }
  function buildCard(e) {
    var t = document.createElement('div'); t.innerHTML = cardHTML(e);
    var c = t.firstElementChild; setFinalState(c, phase === 'final'); return c;
  }
  function applyCols() {
    var cols = mqSP.matches ? 2 : 3;
    qa(grid, '.hx-entry').forEach(function (c, i) { c.style.setProperty('--i', i % cols); });
  }
  // 並び順の説明・各カードの増分・24時間の1〜3位の印（同数は同順位。その数以上が4作品以上なら付けない。0には付けない。本戦は FINALIST と重なるので印なし）
  function jstStamp(iso) {
    var d = new Date(new Date(iso).getTime() + 9 * 3600e3);
    if (isNaN(d)) return '';
    return (d.getUTCMonth() + 1) + '/' + d.getUTCDate() + ' ' + d.getUTCHours() + ':' + ('0' + d.getUTCMinutes()).slice(-2);
  }
  function decorateDaily() {
    var on = dailyReady();
    var note = q(document, '.hx-daily-note');
    if (!on) { if (note) note.parentNode.removeChild(note); }
    else {
      if (!note) { note = document.createElement('p'); note.className = 'hx-daily-note'; grid.parentNode.insertBefore(note, grid); }
      var at = jstStamp(RANK.at);
      note.innerHTML = '<b>並び順</b>' + (at ? at + ' に集計した、' : '') + '24時間の応援（♡）が多い順。毎日12:00に更新。累計はランキングで。';
    }
    var counts = ENTRIES.map(daily);
    qa(grid, '.hx-entry').forEach(function (c) {
      var e = byId(c.getAttribute('data-id'));
      ['.hx-entry__daily', '.hx-entry__rank'].forEach(function (s) { var x = q(c, s); if (x) x.parentNode.removeChild(x); });
      c.classList.remove('is-top', 'is-top1');
      if (!on) return;
      var n = daily(e);
      q(c, '.hx-entry__team').insertAdjacentHTML('afterend', '<p class="hx-entry__daily"><b>♡+' + fmt(n) + '</b></p>');
      var rank = 1 + counts.filter(function (x) { return x > n; }).length;
      // 同数で4作品以上になる順位には付けない（同じ数の一部だけに印が付く不公平を避ける）
      var ge = counts.filter(function (x) { return x >= n; }).length;
      if (n <= 0 || ge > 3 || phase === 'final') return;
      c.classList.add('is-top'); if (rank === 1) c.classList.add('is-top1');
      q(c, '.hx-entry__img').insertAdjacentHTML('beforeend', '<span class="hx-entry__rank"><span><b>' + rank + '</b><small>位</small></span><em>24時間の応援</em></span>');
    });
  }
  // 集計が届いたら、カードを作り直さずに並べ替える（押しかけのタップ・開いている作品詳細・表示アニメーションを壊さない）
  function reorderEntries() {
    var frag = document.createDocumentFragment();
    visibleEntries(phase).forEach(function (e) { var c = q(grid, '[data-id="' + e.id + '"]'); if (c) frag.appendChild(c); });
    grid.appendChild(frag);
    applyCols();
    decorateDaily();
  }
  function renderEntries() {
    grid.innerHTML = visibleEntries(phase).map(cardHTML).join('');
    qa(grid, '.hx-entry').forEach(function (c) { setFinalState(c, phase === 'final'); observe(c); });
    applyCols();
    decorateDaily();
    updateToday();
  }
  function updateToday() {
    var list = visibleEntries(phase);
    var n = list.filter(likedToday).length;
    var c = q(document, '[data-today-count]'); var t = q(document, '[data-today-total]');
    if (c) c.textContent = n;
    if (t) t.textContent = list.length;
  }

  /* ------------------------------------------------------------
     ranking: 予約注文数（本戦進出の基準）と いいね数
     行は data-rank-id で保持し、順位が変わった時だけ FLIP で滑らせる
     ------------------------------------------------------------ */
  // 順位を出せるか。数値がすべて 0（未連携・集計前）の間は案内を出す。API モードは 12:00 の集計（rank）が届いてから
  function rankReady() {
    if (API) return !!RANK && ENTRIES.some(function (e) { return e.snap.orders > 0 || e.snap.likes > 0; });
    return ENTRIES.some(function (e) { return likeCount(e) > 0 || e.orders > 0; });
  }
  function rankRows(key) {
    if (API && !rankReady()) return [];
    var pool = visibleEntries(phase);
    var k = key === 'sales' ? 'orders' : 'likes';
    var val = function (e) { return rankVal(e, k); };
    var now = pool.slice().sort(byRank(k, rankVal));
    var was = pool.slice().sort(byRank(k, function (e, x) { return e.prev[x]; }));
    // 前回の集計が無い日と、予約数→決済済みに切り替えた最初の集計（11/1 12:00）は全員「－」（動いたように見せない）
    var firstPaid = API && paidRank() && Date.parse(RANK.at) < SALE_AT + 864e5;
    var keep = API && (!RANK.prev || firstPaid);
    return now.slice(0, 5).map(function (e, i) {
      var p = was.indexOf(e) + 1;
      return {
        e: e, v: val(e),
        u: key === 'sales' ? '足' : '♡',
        sub: key === 'sales' ? '♡ ' + fmt(rankVal(e, 'likes')) : (paidRank() ? '決済済み ' : '予約 ') + fmt(rankVal(e, 'orders')) + '足',
        delta: keep ? 0 : p > 5 ? 'new' : p - (i + 1)
      };
    });
  }
  function rowHTML(e) {
    return '<button class="hx-rank__row" type="button" data-rank-id="' + e.id + '" data-open-entry="' + e.id + '">' +
      '<span class="hx-rank__bar" aria-hidden="true"></span>' +
      '<span class="hx-rank__no"><b data-rank-no></b><small>位</small><em class="hx-rank__delta" data-rank-delta></em></span>' +
      '<span class="hx-rank__thumb"><img src="' + asset('loop', e.img) + '" alt="" loading="lazy" decoding="async" width="360" height="480"></span>' +
      '<span class="hx-rank__name"><small>' + e.no + ' ・ ' + e.members + '</small>' + e.title + '</span>' +
      '<span class="hx-rank__pt"><b data-rank-val></b><small data-rank-unit></small><span data-rank-sub></span></span>' +
      '<span class="hx-sr">。詳細を見る</span>' +
    '</button>';
  }
  function bump(el) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
  function updateRow(row, r, idx, max, animate) {
    row.style.setProperty('--i', idx);
    row.style.setProperty('--w', (max ? r.v / max : 0).toFixed(3));
    q(row, '[data-rank-no]').textContent = idx + 1;
    var val = q(row, '[data-rank-val]'); var txt = fmt(r.v);
    if (val.textContent !== txt) { val.textContent = txt; if (animate && heavyOK()) bump(val); }
    q(row, '[data-rank-unit]').textContent = r.u;
    q(row, '[data-rank-sub]').textContent = r.sub;
    var d = q(row, '[data-rank-delta]'); var cls = 'hx-rank__delta', t, lab;
    if (r.delta === 'new') { cls += ' is-new'; t = 'NEW'; lab = '前回圏外から浮上'; }
    else if (r.delta > 0) { cls += ' is-up'; t = '▲' + r.delta; lab = '前回より' + r.delta + '位上昇'; }
    else if (r.delta < 0) { cls += ' is-down'; t = '▼' + (-r.delta); lab = '前回より' + (-r.delta) + '位下降'; }
    else { cls += ' is-keep'; t = '－'; lab = '前回と同順位'; }
    d.className = cls; d.innerHTML = t + '<span class="hx-sr">（' + lab + '）</span>';
  }
  function renderRankList(key, animate) {
    var el = q(document, '[data-rank="' + key + '"]');
    if (!el) return;
    // 集計が未連携（数値がすべて 0）の間は、順位の代わりに案内を出す
    if (!rankReady()) {
      if (!el.querySelector('.hx-rank__pending')) el.innerHTML = '<p class="hx-rank__pending">集計は予約販売のスタート後に表示します</p>';
      return;
    }
    var pend = el.querySelector('.hx-rank__pending');
    if (pend) pend.parentNode.removeChild(pend);
    var list = rankRows(key);
    var max = list.length ? Math.max(list[0].v, 1) : 1;
    var before = {}, existing = {};
    qa(el, '[data-rank-id]').forEach(function (r) {
      var id = r.getAttribute('data-rank-id');
      existing[id] = r;
      if (animate) before[id] = r.getBoundingClientRect().top;
    });
    var ids = list.map(function (r) { return r.e.id; });
    var current = qa(el, '[data-rank-id]').map(function (r) { return r.getAttribute('data-rank-id'); });
    if (current.join() === ids.join()) { // 順序不変: 数値だけ差し替え（DOM を動かすと入場アニメが再始動する）
      list.forEach(function (r, idx) { updateRow(existing[r.e.id], r, idx, max, animate); });
      return;
    }
    var frag = document.createDocumentFragment();
    Object.keys(existing).forEach(function (id) { if (ids.indexOf(id) === -1) el.removeChild(existing[id]); });
    list.forEach(function (r, idx) {
      var row = existing[r.e.id];
      if (!row) { var t = document.createElement('div'); t.innerHTML = rowHTML(r.e); row = t.firstElementChild; }
      else row.classList.add('is-settled');
      updateRow(row, r, idx, max, animate);
      frag.appendChild(row);
    });
    el.appendChild(frag);
    if (!animate || !heavyOK() || !inView(el, 200)) return;
    var moved = [];
    qa(el, '[data-rank-id]').forEach(function (r) {
      var id = r.getAttribute('data-rank-id');
      if (before[id] == null) return; // 新規行は CSS の入場アニメに任せる
      var dy = before[id] - r.getBoundingClientRect().top;
      if (!dy) return;
      r.style.transition = 'none';
      r.style.transform = 'translateY(' + dy + 'px)';
      moved.push(r);
    });
    if (!moved.length) return;
    void el.offsetWidth;
    moved.forEach(function (r) { r.style.transition = ''; r.style.transform = ''; r.classList.add('is-move'); });
    setTimeout(function () { moved.forEach(function (r) { r.classList.remove('is-move'); }); }, 500);
  }
  function renderRanking(animate) {
    var box = q(document, '#ranking .hx-rank');
    var ready = rankReady();
    if (box) {
      box.classList.toggle('is-pending', !ready);
      // 初回集計前は予定日時を案内。全件0や取得待ちでも仮の順位は出さない。
      var startJst = new Date(START_AT.getTime() + 9 * 3600000);
      var first = Date.UTC(startJst.getUTCFullYear(), startJst.getUTCMonth(), startJst.getUTCDate(), 3);
      if (first < START_AT.getTime()) first += 86400000;
      var firstJst = new Date(first + 9 * 3600000);
      var beforeFirst = Date.now() < first;
      var title = q(box, '[data-rank-intro-title]');
      var date = q(box, '[data-rank-intro-date]');
      if (title) title.textContent = beforeFirst ? '最初の応援速報を、お楽しみに。' : '応援が集まると、ここに順位が表示されます。';
      if (date) date.textContent = beforeFirst ? '初回更新 ' + (firstJst.getUTCMonth() + 1) + '月' + firstJst.getUTCDate() + '日 12:00 予定' : '';
    }
    renderRankList('sales', animate);
    renderRankList('likes', animate);
    var lbl = q(document, '[data-rank-label]');
    if (lbl) lbl.textContent = phase === 'final' ? '本戦 中間発表' : '予選 中間発表';
    var ttl = q(document, '[data-rank-title]');
    if (ttl) ttl.textContent = phase === 'final' ? '頂点に立つのは、どのチーム？' : '本戦へ進むのは、どのチーム？';
    tickerDirty = true;
  }

  /* ------------------------------------------------------------
     phase labels / toggle（デモ）
     ------------------------------------------------------------ */
  function phaseLabel() {
    return phase === 'final' ? '本戦 開催中' : Date.now() < START_AT.getTime() ? '予選 受付開始前' : '予選 開催中';
  }
  function applyPhaseLabels() {
    var lab = q(document, '[data-phase-label]');
    var btn = q(document, '[data-phase-toggle]');
    if (lab) lab.textContent = phaseLabel();
    if (btn) btn.textContent = phase === 'final' ? '予選の表示に戻す（デモ）' : '本戦の表示を見る（デモ）';
    qa(document, '.hx-kv__phase li').forEach(function (li, i) { var now = (phase === 'final' ? 2 : 0) === i; li.classList.toggle('is-now', now); if (now) li.setAttribute('aria-current', 'step'); else li.removeAttribute('aria-current'); });
    var cj = q(document, '.hx-cta__ja');
    if (cj) cj.textContent = visibleEntries(phase).length + 'チームの作品を見て応援する';
  }
  var switching = false;
  function switchPhase(next) {
    if (switching || next === phase) return;
    switching = true;
    var cards = qa(grid, '.hx-entry');
    var willShow = visibleEntries(next).map(function (e) { return e.id; });
    var before = {}, sy0 = window.scrollY || 0;
    cards.forEach(function (c) { var r = c.getBoundingClientRect(); before[c.getAttribute('data-id')] = { left: r.left, top: r.top + sy0 }; });
    var outgoing = cards.filter(function (c) { return willShow.indexOf(c.getAttribute('data-id')) === -1; });
    var animOut = heavyOK() ? outgoing.filter(function (c) { return inView(c, 0); }) : [];
    outgoing.forEach(function (c) { if (animOut.indexOf(c) === -1) grid.removeChild(c); else c.classList.add('is-out'); });
    setTimeout(function () {
      animOut.forEach(function (c) { if (c.parentNode) grid.removeChild(c); });
      phase = next;
      var existing = {};
      qa(grid, '.hx-entry').forEach(function (c) { existing[c.getAttribute('data-id')] = c; });
      var frag = document.createDocumentFragment(); var incoming = [];
      willShow.forEach(function (id) {
        var c = existing[id];
        if (!c) { c = buildCard(byId(id)); incoming.push(c); }
        else c.classList.add('is-settled');
        frag.appendChild(c);
      });
      grid.appendChild(frag);
      applyCols();
      decorateDaily();
      // 残ったカードは FLIP で新しい位置へ
      var flips = [], sy1 = window.scrollY || 0;
      if (heavyOK()) Object.keys(existing).forEach(function (id) {
        var c = existing[id], b = before[id]; if (!b) return;
        var a = c.getBoundingClientRect();
        var dx = b.left - a.left, dy = b.top - (a.top + sy1);
        if ((!dx && !dy) || Math.abs(dy) > window.innerHeight * 1.5) return;
        c.style.transition = 'none';
        c.style.transform = 'translate(' + dx + 'px,' + dy + 'px)';
        flips.push(c);
      });
      if (flips.length) {
        void grid.offsetWidth;
        flips.forEach(function (c) { c.style.transition = 'transform var(--dur-m) var(--ease-out)'; c.style.transform = ''; });
        setTimeout(function () { flips.forEach(function (c) { c.style.transition = ''; }); }, 450);
      }
      // 戻ってくるカード: 画面内は入場アニメ、画面外は IO に任せる
      incoming.forEach(function (c) { if (inView(c, 0)) c.classList.add('is-in'); else observe(c); });
      qa(grid, '.hx-entry').forEach(function (c) { setFinalState(c, next === 'final'); });
      applyPhaseLabels();
      renderRanking(true);
      updateToday();
      switching = false;
    }, animOut.length ? 230 : 0);
  }
  document.addEventListener('click', function (ev) {
    if (!ev.target.closest('[data-phase-toggle]')) return;
    switchPhase(phase === 'final' ? 'prelim' : 'final');
  });

  /* ------------------------------------------------------------
     like handling
     ------------------------------------------------------------ */
  function roll(numEl, text) {
    var cur = q(numEl, '.hx-like__n');
    if (!cur || cur.textContent === text) { if (!cur) numEl.innerHTML = '<span class="hx-like__n">' + text + '</span>'; return; }
    if (!heavyOK() || !inView(numEl, 0)) { cur.textContent = text; return; }
    qa(numEl, '.hx-like__n.is-out').forEach(function (o) { o.parentNode.removeChild(o); });
    cur.classList.add('is-out');
    var nu = document.createElement('span'); nu.className = 'hx-like__n is-roll'; nu.textContent = text;
    numEl.appendChild(nu);
    setTimeout(function () { if (cur.parentNode) cur.parentNode.removeChild(cur); nu.classList.remove('is-roll'); }, 420);
  }
  function updateCounts(id) {
    var e = byId(id);
    qa(document, '[data-count="' + id + '"]').forEach(function (el) { roll(el, fmt(likeCount(e))); });
    qa(document, '[data-like="' + id + '"]').forEach(function (b) {
      b.classList.toggle('is-on', likedToday(e));
      b.setAttribute('aria-pressed', likedToday(e) ? 'true' : 'false');
      b.setAttribute('aria-label', likeLabel(e));
    });
  }
  function pop(btn, cls, ms) {
    btn.classList.remove(cls); void btn.offsetWidth; btn.classList.add(cls);
    setTimeout(function () { btn.classList.remove(cls); }, ms || 600);
  }
  // 応援した瞬間の演出: 波紋・大きなハートが浮き上がる・ハートの粒・+1（スマホの全幅ボタンでも見えるよう大きめ）
  function burst(btn) {
    if (!heavyOK()) return;
    if (!q(btn, '.hx-like__fx')) {
      var h = '<span class="hx-like__fx" aria-hidden="true"><i class="hx-like__ring"></i>' +
        '<svg class="hx-like__fly" viewBox="0 0 24 24"><path d="' + HEART_PATH + '"/></svg><b class="hx-like__plus">+1</b>';
      for (var k = 0; k < 10; k++) {
        h += '<i class="hx-like__p" style="--a:' + (k * 36 + (k % 2 ? 14 : 0)) + 'deg;--d:' + (k % 2 ? 26 : 40) + 'px;--t:' + (k % 3) * 40 + 'ms">' +
          (k % 2 ? '' : '<svg viewBox="0 0 24 24"><path d="' + HEART_PATH + '"/></svg>') + '</i>';
      }
      btn.insertAdjacentHTML('beforeend', h + '</span>');
    }
    var fx = q(btn, '.hx-like__fx'), ic = q(btn, 'svg'), b = btn.getBoundingClientRect(), r = ic ? ic.getBoundingClientRect() : b;
    fx.style.left = (r.left + r.width / 2 - b.left) + 'px'; // ハートのアイコンの位置から出す
    fx.style.top = (r.top + r.height / 2 - b.top) + 'px';
    pop(btn, 'is-burst', 1400);
  }
  function announce(text) {
    var open = q(document, '.hx-modal.is-open [data-live]');
    var l = open || q(document, 'body > [data-live]');
    if (l) { l.textContent = ''; setTimeout(function () { l.textContent = text; }, 30); }
  }
  // ボタン上の吹き出し。text を渡すとその回だけ文言を差し替え、消えたあと既定の文言に戻す
  var TIP = '今日はもう応援済み。また明日！';
  function tip(btn, text) {
    var el = q(btn, '.hx-like__tip');
    var my = btn._tip = (btn._tip || 0) + 1; // 連打時は最後の1回だけが閉じる
    if (el) el.textContent = text || TIP;
    pop(btn, 'is-shake', 500);
    btn.classList.add('is-tip');
    setTimeout(function () {
      if (btn._tip !== my) return;
      btn.classList.remove('is-tip');
      setTimeout(function () { if (btn._tip === my && el) el.textContent = TIP; }, 250); // フェードアウト後に戻す
    }, 1600);
  }
  function startLabel() { var d = jst(START_AT.getTime()); return (d.getUTCMonth() + 1) + '/' + d.getUTCDate() + ' ' + d.getUTCHours() + ':' + pad(d.getUTCMinutes()); } // 例: 10/16 10:00
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-like]');
    if (!btn) return;
    var id = btn.getAttribute('data-like');
    var e = byId(id);
    if (!e) return;
    if (API && Date.now() < START_AT.getTime()) { // 受付開始前は送らない
      var msg = '応援は' + startLabel() + 'から';
      tip(btn, msg);
      announce(msg);
      return;
    }
    if (likedToday(e)) {
      tip(btn);
      announce(e.title + ' は今日はもう応援済みです。また明日');
      return;
    }
    var prevDate = store.dates[id];
    if (API) e.likes += 1; // 楽観表示。結果が来たらサーバーの数に置き換える（失敗なら戻す）
    else store.likes[id] = (store.likes[id] || 0) + 1;
    store.dates[id] = today();
    save();
    updateCounts(id);
    pop(btn, 'is-pop');
    burst(btn);
    if (navigator.vibrate && motionOK()) { try { navigator.vibrate(10); } catch (err) {} }
    announce(e.title + ' を応援しました。いいね ' + fmt(likeCount(e)));
    if (API) { e.wait = true; enqueue({ e: e, prev: prevDate }); }
    else renderRanking(true); // API モードの順位は 12:00 の集計なので、押しても並び替えない
    updateToday();
  });

  /* ------------------------------------------------------------
     modals（開閉の振り付け・フォーカストラップ・iOS スクロールロック）
     ------------------------------------------------------------ */
  var lastFocus = null, opening = false, closing = false, pendingOpen = null, lockY = 0;
  var modalEntry = document.getElementById('modal-entry');
  function lockBody() {
    lockY = window.scrollY || window.pageYOffset || 0;
    var sbw = window.innerWidth - root.clientWidth; // クラシックスクロールバー環境の横ズレ防止
    document.body.style.top = -lockY + 'px';
    document.body.style.paddingRight = sbw > 0 ? sbw + 'px' : '';
    document.body.classList.add('is-locked');
  }
  function unlockBody() {
    document.body.classList.remove('is-locked');
    document.body.style.top = '';
    document.body.style.paddingRight = '';
    root.style.scrollBehavior = 'auto';
    window.scrollTo(0, lockY);
    root.style.scrollBehavior = '';
  }
  function focusables(el) {
    return qa(el, 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])').filter(function (f) { return f.offsetParent !== null; });
  }
  function openModal(el) {
    if (el.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    lockBody();
    void el.offsetWidth;
    el.classList.add('is-shown');
    var box = q(el, '.hx-modal__box'); if (box) box.focus({ preventScroll: true });
  }
  function closeModals() {
    var open = qa(document, '.hx-modal.is-open');
    if (!open.length || closing) return;
    closing = true;
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true }); // aria-hidden を付ける前にフォーカスを戻す
    open.forEach(function (m) { m.classList.remove('is-shown'); m.setAttribute('aria-hidden', 'true'); });
    var finish = function () {
      open.forEach(function (m) { m.classList.remove('is-open'); });
      unlockBody();
      closing = false;
      if (pendingOpen) { var p = pendingOpen; pendingOpen = null; openEntry(p); }
    };
    setTimeout(finish, motionOK() ? 420 : 0);
  }
  /* entry modal */
  var navList = [], navIdx = -1;
  function preload(e) { if (e) { var im = new Image(); im.src = asset('entry', e.img); } }
  function fillEntry(e) {
    var m = modalEntry;
    var g = function (k) { return q(m, '[data-m="' + k + '"]'); };
    var img = g('img');
    if (img.getAttribute('src') !== asset('entry', e.img)) img.src = asset('entry', e.img);
    img.alt = e.title;
    g('team').textContent = e.no + ' ／ ' + e.members + (isFinalist(e) && phase === 'final' ? ' ／ 本戦進出' : '');
    g('title').textContent = e.title;
    g('concept').textContent = e.concept;
    g('buy').href = e.url || SHOP;
    if (e.kv) { g('kv').src = asset('kv', e.kv); g('kv').alt = e.title + ' キービジュアル'; }
    qa(m, '[data-m-kv]').forEach(function (el) { el.hidden = !e.kv; });
    g('like-slot').innerHTML = likeBtn(e);
    g('counter').textContent = pad(navIdx + 1) + ' / ' + pad(navList.length);
    var url = location.origin + location.pathname + '?e=' + e.id + (phase === 'final' ? '&phase=final' : '');
    var text = '「' + e.title + '」を応援中！ HOTSOX PROMOTION BATTLE 5 — 学生21チームの靴下デザインバトル';
    var x = q(m, '[data-share-x]'), ln = q(m, '[data-share-line]');
    if (x) x.href = 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(text) + '&url=' + encodeURIComponent(url);
    if (ln) ln.href = 'https://social-plugins.line.me/lineit/share?url=' + encodeURIComponent(url);
    m.setAttribute('data-share-url', url);
    m.setAttribute('data-share-text', text);
    preload(navList[navIdx + 1]); preload(navList[navIdx - 1]);
  }
  function openEntry(id) {
    var e = byId(id); if (!e || opening) return;
    if (closing) { pendingOpen = id; return; }
    navList = visibleEntries(phase);
    navIdx = navList.indexOf(e);
    if (navIdx === -1) return; // 現在のフェーズで表示していない作品は開かない
    if (modalEntry.classList.contains('is-open')) { fillEntry(e); return; }
    opening = true;
    var im = new Image(); im.src = asset('entry', e.img);
    var go = function () { if (!opening) return; opening = false; fillEntry(e); openModal(modalEntry); };
    var p = im.decode ? im.decode() : Promise.resolve();
    var t = setTimeout(go, 350);
    p.then(function () { clearTimeout(t); go(); }, function () { clearTimeout(t); go(); });
  }
  var navBusy = false;
  function navEntry(dir) {
    if (!navList.length || !modalEntry.classList.contains('is-open') || navBusy) return;
    var next = (navIdx + dir + navList.length) % navList.length;
    var e = navList[next];
    var gd = q(modalEntry, '.hx-modal__grid');
    announce(e.title + '（' + (next + 1) + ' / ' + navList.length + '）');
    if (!heavyOK()) { navIdx = next; fillEntry(e); return; }
    navBusy = true;
    gd.style.setProperty('--dx', (-dir * 16) + 'px');
    gd.classList.add('is-swap');
    setTimeout(function () {
      navBusy = false;
      navIdx = next; fillEntry(e);
      gd.style.transition = 'none';
      gd.style.setProperty('--dx', (dir * 16) + 'px');
      void gd.offsetWidth;
      gd.style.transition = '';
      gd.classList.remove('is-swap');
    }, 110);
  }
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    var o = t.closest('[data-open-entry]');
    if (o) { openEntry(o.getAttribute('data-open-entry')); return; }
    var nv = t.closest('[data-modal-nav]');
    if (nv) { navEntry(parseInt(nv.getAttribute('data-modal-nav'), 10) || 1); return; }
    var op = t.closest('[data-open]');
    if (op) { openModal(document.getElementById('modal-' + op.getAttribute('data-open'))); return; }
    if (t.closest('[data-close]')) closeModals();
  });
  document.addEventListener('keydown', function (ev) {
    var open = q(document, '.hx-modal.is-open');
    if (!open) return;
    if (ev.key === 'Escape') { closeModals(); return; }
    if (ev.altKey || ev.metaKey || ev.ctrlKey) return;
    if (open === modalEntry && ev.key === 'ArrowRight') { ev.preventDefault(); navEntry(1); return; }
    if (open === modalEntry && ev.key === 'ArrowLeft') { ev.preventDefault(); navEntry(-1); return; }
    if (ev.key !== 'Tab') return;
    var f = focusables(open); if (!f.length) return;
    var idx = f.indexOf(document.activeElement); // -1 = ダイアログ箱自体にフォーカスがある
    if (ev.shiftKey && idx <= 0) { ev.preventDefault(); f[f.length - 1].focus(); }
    else if (!ev.shiftKey && (idx === -1 || idx === f.length - 1)) { ev.preventDefault(); f[0].focus(); }
  });
  /* swipe（SP: 左右で前後の作品へ） */
  (function () {
    var box = q(modalEntry, '.hx-modal__box'); if (!box) return;
    var sx = 0, sy = 0, on = false;
    box.addEventListener('pointerdown', function (ev) { if (ev.pointerType === 'mouse') return; sx = ev.clientX; sy = ev.clientY; on = true; }, { passive: true });
    box.addEventListener('pointerup', function (ev) {
      if (!on) return; on = false;
      var dx = ev.clientX - sx, dy = ev.clientY - sy;
      if (Math.abs(dx) > 48 && Math.abs(dy) < 40) navEntry(dx < 0 ? 1 : -1);
    }, { passive: true });
    box.addEventListener('pointercancel', function () { on = false; }, { passive: true });
  })();
  /* share */
  document.addEventListener('click', function (ev) {
    var s = ev.target.closest('[data-share]');
    var cp = ev.target.closest('[data-share-copy]');
    if (!s && !cp) return;
    var url = modalEntry.getAttribute('data-share-url') || location.href;
    var text = modalEntry.getAttribute('data-share-text') || document.title;
    if (s) {
      if (navigator.share) { navigator.share({ title: document.title, text: text, url: url }).catch(noop); return; }
      var links = q(modalEntry, '.hx-share__links'); if (links) links.classList.add('is-open');
      return;
    }
    var done = function () { cp.classList.add('is-done'); cp.textContent = 'コピーしました'; setTimeout(function () { cp.classList.remove('is-done'); cp.textContent = 'リンクをコピー'; }, 1800); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, noop);
    else { window.prompt('このURLをコピーしてください', url); }
  });

  /* ------------------------------------------------------------
     hero streams (looping sock tiles) — 回転は静的なランダム値
     ------------------------------------------------------------ */
  var streamMode = null;
  function rot(i) { var r = ((i * 9301 + 49297) % 233280) / 233280; return ((i % 2 ? 2 : -2) + (r * 4 - 2)).toFixed(1); }
  function tiles(list) {
    var html = '';
    list.concat(list).forEach(function (f, i) { html += '<div class="hx-stream__tile" style="--r:' + rot(i) + 'deg"><img src="' + asset('loop', f) + '" alt="" loading="lazy" decoding="async" width="360" height="480"></div>'; });
    return html;
  }
  function renderStreams() {
    var mode = mqSP.matches ? 'sp' : 'pc';
    if (mode === streamMode) return;
    streamMode = mode;
    var imgs = ENTRIES.map(function (e) { return e.img; });
    var left = q(document, '[data-stream="left"]');
    var right = q(document, '[data-stream="right"]');
    var row = q(document, '[data-stream="row"]');
    if (mode === 'pc') {
      left.innerHTML = tiles(imgs.filter(function (_, i) { return i % 2 === 0; }).slice(0, 9));
      right.innerHTML = tiles(imgs.filter(function (_, i) { return i % 2 === 1; }).slice(0, 9));
      row.innerHTML = '';
    } else {
      row.innerHTML = tiles(imgs.slice(0, 10));
      left.innerHTML = ''; right.innerHTML = '';
    }
  }
  var kvImg = q(document, '.hx-kv__art .hx-fv__ph img') || q(document, '.hx-kv__art img');
  if (kvImg && kvImg.decode && !kvImg.complete) kvImg.decode().then(renderStreams, renderStreams); else renderStreams();
  setTimeout(renderStreams, 1200); // decode が遅い場合の保険
  onMQ(mqSP, function () { renderStreams(); applyCols(); });

  /* 画面外の無限アニメーションを止める（KV ストリーム・ティッカー） */
  if (io) {
    var pauser = new IntersectionObserver(function (ens) {
      ens.forEach(function (en) { en.target.classList.toggle('is-off', !en.isIntersecting); });
    }, { threshold: 0 });
    qa(document, '.hx-kv, .hx-ticker, .hx-status').forEach(function (el) { pauser.observe(el); });
  }

  /* ------------------------------------------------------------
     header drawer (SP)
     ------------------------------------------------------------ */
  var drawer = document.getElementById('drawer');
  var menuBtn = q(document, '[data-menu-toggle]');
  function setMenu(open) {
    if (!drawer || !menuBtn) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    menuBtn.classList.toggle('is-open', open);
    menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    menuBtn.setAttribute('aria-label', open ? 'メニューを閉じる' : 'メニューを開く');
    document.body.classList.toggle('is-menu', open);
  }
  if (menuBtn) menuBtn.addEventListener('click', function () { setMenu(!drawer.classList.contains('is-open')); });
  qa(document, '[data-menu-close]').forEach(function (a) { a.addEventListener('click', function () { setMenu(false); }); });
  document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') setMenu(false); });
  onMQ(mqSP, function (e) { if (!e.matches) setMenu(false); });

  /* ------------------------------------------------------------
     ticker: 固定文言 + ランキング1位・カウントダウンを動的に追加
     ------------------------------------------------------------ */
  var tk = q(document, '[data-ticker]');
  var tickerBase = tk ? qa(tk, '.hx-ticker__item').map(function (s) { return s.textContent; }) : [];
  var tickerDirty = false;
  function daysLeft() { return Math.floor((START_AT - new Date()) / 864e5); }
  function renderTicker() {
    if (!tk) return;
    var items = tickerBase.slice();
    var s = rankRows('sales')[0], l = rankRows('likes')[0];
    if (s) items.push('Sales 1st: ' + s.e.title + ' — ' + fmt(s.v) + ' pairs');
    if (l) items.push('Likes 1st: ' + l.e.title + ' — ♡' + fmt(l.v));
    var d = daysLeft();
    items.push(d >= 1 ? 'Pre-order starts in ' + d + ' day' + (d === 1 ? '' : 's') : (START_AT - new Date() > 0 ? 'Pre-order starts today' : 'Pre-order now open'));
    var html = items.map(function (t) { return '<span class="hx-ticker__item">' + t + '</span>'; }).join('');
    tk.innerHTML = html + html;
    tickerDirty = false;
  }
  if (tk) tk.addEventListener('animationiteration', function () { if (tickerDirty) renderTicker(); });

  /* ------------------------------------------------------------
     countdown（日数のみ・1分更新。10/16 10:00 JST 以降は「予約受付中」）
     ------------------------------------------------------------ */
  function tickCountdown() {
    var cd = q(document, '[data-countdown]');
    var sub = q(document, '[data-cta-sub]');
    var diff = START_AT - new Date();
    var lab = q(document, '[data-phase-label]');
    if (lab) lab.textContent = phaseLabel();
    if (diff <= 0) {
      if (cd) cd.innerHTML = '<b>予約受付中</b>';
      if (sub) sub.textContent = 'NOW OPEN';
      root.classList.add('is-started');
      return;
    }
    var days = Math.floor(diff / 864e5), hours = Math.floor((diff % 864e5) / 36e5), mins = Math.floor((diff % 36e5) / 6e4);
    var html;
    if (days >= 1) html = '予約開始まで <b>あと <em>' + days + '</em> 日' + (days < 3 ? ' <em>' + hours + '</em> 時間' : '') + '</b>';
    else if (hours >= 1) html = '予約開始まで <b>あと <em>' + hours + '</em> 時間 <em>' + mins + '</em> 分</b>';
    else html = '<b>まもなく予約開始（あと <em>' + Math.max(mins, 1) + '</em> 分）</b>';
    if (cd && cd.innerHTML !== html) cd.innerHTML = html;
    var subText = days >= 1 ? 'あと' + days + '日' : hours >= 1 ? 'あと' + hours + '時間' : 'まもなく';
    if (sub && sub.textContent !== subText) sub.textContent = subText;
  }
  tickCountdown();
  setInterval(tickCountdown, 60000);

  /* ------------------------------------------------------------
     observe static reveal targets
     ------------------------------------------------------------ */
  qa(document, '[data-rv]').forEach(observe);

  /* fixed CTA: show after the key visual, hide at the footer */
  var cta = document.getElementById('cta');
  var kv = q(document, '.hx-kv');
  var foot = q(document, '.hx-foot');
  var kvOut = false, footIn = false;
  function syncCta() { if (cta) cta.classList.toggle('is-show', kvOut && !footIn); }
  if (io && kv && foot) {
    new IntersectionObserver(function (en) { kvOut = !en[0].isIntersecting; syncCta(); }, { threshold: 0.35 }).observe(kv);
    new IntersectionObserver(function (en) { footIn = en[0].isIntersecting; syncCta(); }, { threshold: 0.4 }).observe(foot);
  }

  /* ------------------------------------------------------------
     PC only: nav scrollspy / KV pointer parallax / card tilt
     ------------------------------------------------------------ */
  function initSpy() {
    var links = qa(document, '.hx-head__nav a[href^="#"]');
    if (!links.length || !io || mqSP.matches) return;
    var map = {};
    links.forEach(function (a) { map[a.getAttribute('href').slice(1)] = a; });
    var spy = new IntersectionObserver(function (ens) {
      ens.forEach(function (en) {
        if (!en.isIntersecting) return;
        links.forEach(function (l) { l.classList.remove('is-active'); });
        map[en.target.id].classList.add('is-active');
      });
    }, { rootMargin: '-35% 0px -60% 0px', threshold: 0 });
    Object.keys(map).forEach(function (id) { var s = document.getElementById(id); if (s) spy.observe(s); });
  }
  var parallaxOn = false;
  function initKvParallax() {
    if (parallaxOn || !kv || !mqFine.matches || !heavyOK()) return;
    parallaxOn = true;
    var tx = 0, ty = 0, cx = 0, cy = 0, raf = 0;
    var targets = qa(kv, '.hx-kv__art, .hx-stream'); // KV 全体でなく必要な部分木だけに変数を置く
    function step() {
      cx += (tx - cx) * 0.08; cy += (ty - cy) * 0.08;
      targets.forEach(function (t) { t.style.setProperty('--kx', cx.toFixed(3)); t.style.setProperty('--ky', cy.toFixed(3)); });
      if (Math.abs(tx - cx) > 0.002 || Math.abs(ty - cy) > 0.002) raf = requestAnimationFrame(step); else raf = 0;
    }
    function kick() { if (!raf) raf = requestAnimationFrame(step); }
    kv.addEventListener('pointermove', function (ev) {
      if (ev.pointerType !== 'mouse') return;
      tx = ev.clientX / window.innerWidth - 0.5;
      ty = ev.clientY / window.innerHeight - 0.5;
      kick();
    }, { passive: true });
    kv.addEventListener('pointerleave', function () { tx = 0; ty = 0; kick(); });
  }
  var tiltOn = false;
  function initTilt() {
    if (tiltOn || !grid || !mqTilt.matches || !heavyOK()) return;
    tiltOn = true;
    var cur = null, rect = null, raf = 0, px = 0, py = 0;
    function apply() {
      raf = 0; if (!cur) return;
      cur.style.setProperty('--rx', (-py * 8).toFixed(2) + 'deg');
      cur.style.setProperty('--ry', (px * 10).toFixed(2) + 'deg');
      cur.style.setProperty('--px', (px * -8).toFixed(1) + 'px');
      cur.style.setProperty('--py', (py * -8).toFixed(1) + 'px');
    }
    function leave() {
      if (!cur) return;
      cur.classList.remove('is-hover');
      ['--rx', '--ry', '--px', '--py'].forEach(function (k) { cur.style.removeProperty(k); });
      cur = null;
    }
    grid.addEventListener('pointerover', function (ev) {
      if (ev.pointerType !== 'mouse') return;
      var c = ev.target.closest('.hx-entry');
      if (!c || c === cur) return;
      leave();
      cur = c; rect = c.getBoundingClientRect();
      c.classList.add('is-hover');
    });
    grid.addEventListener('pointermove', function (ev) {
      if (!cur || !rect) return;
      px = (ev.clientX - rect.left) / rect.width - 0.5;
      py = (ev.clientY - rect.top) / rect.height - 0.5;
      if (!raf) raf = requestAnimationFrame(apply);
    }, { passive: true });
    grid.addEventListener('pointerout', function (ev) {
      if (!cur) return;
      var to = ev.relatedTarget;
      if (to && cur.contains(to)) return;
      leave();
    });
  }

  /* ------------------------------------------------------------
     API モード（PB5.api があるときだけ動く）
     - 読み込み時に /v1/counts を1回だけ取得（ポーリングしない）
     - いいねは楽観表示 → 直列キューで1件ずつ POST /v1/like（毎回 Turnstile の新しいトークン）
     - fp / pm / vidAge はサーバーのログ用。ここでは何も止めない
     ------------------------------------------------------------ */
  var MSG_CAP = '不正防止のため、いまお使いの回線（Wi‑Fi など）からのこの作品への応援は、今日の上限に達しました。Wi‑Fi をオフにしてモバイル回線でお試しいただくか、明日またお試しください。';
  var MSG_CLOSED = '応援の受付期間外です';
  var MSG_FAIL = '通信に失敗しました。もう一度お試しください';
  var VID = null; // 投票者ID { id, created }（localStorage hx_pb5_vid）

  function hex(buf) { var a = new Uint8Array(buf), h = ''; for (var i = 0; i < a.length; i++) h += (a[i] + 256).toString(16).slice(1); return h; }
  function uuid() {
    var c = window.crypto, b = new Uint8Array(16), i;
    if (c && c.randomUUID) return c.randomUUID();
    if (c && c.getRandomValues) c.getRandomValues(b); else for (i = 0; i < 16; i++) b[i] = Math.random() * 256 | 0;
    b[6] = (b[6] & 15) | 64; b[8] = (b[8] & 63) | 128; // UUID v4 の形にそろえる
    var h = hex(b.buffer);
    return h.slice(0, 8) + '-' + h.slice(8, 12) + '-' + h.slice(12, 16) + '-' + h.slice(16, 20) + '-' + h.slice(20);
  }
  function voter() {
    var v = null;
    try { v = JSON.parse(localStorage.getItem('hx_pb5_vid') || 'null'); } catch (err) {}
    if (!v || typeof v.id !== 'string' || !v.id || typeof v.created !== 'number') {
      v = { id: uuid(), created: Date.now() };
      try { localStorage.setItem('hx_pb5_vid', JSON.stringify(v)); } catch (err) {}
    }
    return v;
  }

  /* 検知用シグナル（ログ専用） */
  // fp: 端末のおおまかな特徴の SHA-256 先頭32桁。canvas / audio / WebGL は使わない
  function fingerprint() {
    var n = navigator, s = window.screen || {}, c = window.crypto, tz = '';
    try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (err) {}
    var w = s.width || 0, h = s.height || 0;
    var str = [n.userAgent, n.platform, (n.languages || [n.language]).join(','), tz,
      Math.max(w, h) + 'x' + Math.min(w, h) + 'x' + s.colorDepth, // 縦横は画面の回転で入れ替わるので大きい順
      window.devicePixelRatio, n.hardwareConcurrency, n.deviceMemory, n.maxTouchPoints].join('|');
    if (!c || !c.subtle || !window.TextEncoder) return Promise.resolve('');
    return c.subtle.digest('SHA-256', new TextEncoder().encode(str)).then(function (b) { return hex(b).slice(0, 32); }, function () { return ''; });
  }
  // pm: シークレットモードの推定（ヒューリスティック）。true / false / null（不明）、最大300ms
  // - Safari・Firefox のプライベートでは OPFS（storage.getDirectory）が拒否される
  //   （Safari: "unknown transient reason" / Firefox: "Security error"）
  // - Chromium は 133 以降、保存容量が通常・シークレットで同じ値になり、軽い判定が無いので null
  function privateMode() {
    return new Promise(function (resolve) {
      var st = navigator.storage;
      setTimeout(function () { resolve(null); }, 300);
      if (navigator.userAgentData || !st || !st.getDirectory) { resolve(null); return; }
      st.getDirectory().then(function () { resolve(false); }, function (err) {
        resolve(/unknown transient reason|security error/i.test(String((err && err.message) || err)) ? true : null);
      });
    });
  }
  var sigP = null;
  function signals() { if (!sigP) sigP = Promise.all([fingerprint(), privateMode()]); return sigP; }

  /* Turnstile（人間確認）: 通常は見えない。操作が必要な時だけ下中央に出る */
  var tsBox = null, tsP = null, tsId = null, tsWait = null;
  function tsLoad() {
    if (tsP) return tsP;
    tsP = new Promise(function (resolve, reject) {
      window.pb5TsLoaded = function () { resolve(window.turnstile); };
      var s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=pb5TsLoaded';
      s.async = true;
      s.onerror = function () { tsP = null; reject(new Error('turnstile load')); }; // 次の応援で読み直す
      document.head.appendChild(s);
    }).then(function (ts) {
      if (tsId == null) tsId = ts.render(q(tsBox, '.hx-ts__w'), {
        sitekey: TS_KEY,
        action: 'pb5_like',
        execution: 'execute',           // execute() を呼んだ時だけ確認する
        appearance: 'interaction-only', // 操作が必要な時だけ見せる
        theme: 'light',
        retry: 'never',                 // 失敗はこちらで差し戻す
        callback: function (tok) { if (tsWait) tsWait(tok); },
        'error-callback': function (code) { if (tsWait) tsWait(null, code); return true; },
        'timeout-callback': function () { if (tsWait) tsWait(null, 'timeout'); },
        'expired-callback': function () { if (tsWait) tsWait(null, 'expired'); },
        'unsupported-callback': function () { if (tsWait) tsWait(null, 'unsupported'); },
        'before-interactive-callback': function () { toastHide(true); tsBox.classList.add('is-on'); announce(q(tsBox, '.hx-ts__cap').textContent); },
        'after-interactive-callback': function () { tsBox.classList.remove('is-on'); }
      });
      return ts;
    });
    return tsP;
  }
  // 1回分のトークン。execute → callback を待つ（20秒で打ち切り）→ 使ったら reset
  function getToken() {
    if (!TS_KEY) return Promise.resolve(''); // サイトキー未設定: トークンなしで送る（判定はサーバー）
    return new Promise(function (resolve, reject) {
      var timer = setTimeout(function () { done(null, 'timeout'); }, 20000);
      function done(tok, err) {
        if (tsWait !== done) return;
        tsWait = null;
        clearTimeout(timer);
        tsBox.classList.remove('is-on');
        if (tsId != null) { try { window.turnstile.reset(tsId); } catch (x) {} }
        if (tok) resolve(tok); else reject(new Error('turnstile ' + err));
      }
      tsWait = done;
      tsLoad().then(function (ts) { if (tsWait === done) ts.execute(q(tsBox, '.hx-ts__w')); }, function () { done(null, 'load'); });
    });
  }

  /* toast: 長めのお知らせ（下中央・約8秒で消える・閉じるボタン付き） */
  var toastBox = null, toastT = 0;
  function toast(text) {
    if (!toastBox) return;
    toastHide(true);
    var c = document.createElement('div');
    c.className = 'hx-toast__card';
    c.innerHTML = '<svg class="hx-toast__ico" viewBox="0 0 24 24" aria-hidden="true"><path d="' + HEART_PATH + '"/></svg>' +
      '<p class="hx-toast__msg"></p><button class="hx-toast__x" type="button" aria-label="閉じる" data-toast-close></button>';
    q(c, '.hx-toast__msg').textContent = text;
    toastBox.appendChild(c);
    void c.offsetWidth;
    c.classList.add('is-show');
    toastT = setTimeout(toastHide, 8000);
  }
  function toastHide(now) {
    clearTimeout(toastT);
    if (!toastBox) return;
    qa(toastBox, '.hx-toast__card').forEach(function (c) {
      if (now === true || !motionOK()) { toastBox.removeChild(c); return; }
      c.classList.remove('is-show');
      setTimeout(function () { if (c.parentNode) c.parentNode.removeChild(c); }, 250);
    });
  }

  /* 通信 */
  function fetchJSON(url, opt) {
    opt = opt || {};
    var ac = window.AbortController ? new AbortController() : null, timer = 0;
    if (ac) { opt.signal = ac.signal; timer = setTimeout(function () { ac.abort(); }, 10000); } // 応答が無いままキューを止めない
    return fetch(url, opt).then(function (r) {
      return r.json().then(null, function () { return {}; }).then(function (b) { clearTimeout(timer); return { status: r.status, body: b || {} }; });
    }, function (err) { clearTimeout(timer); throw err; });
  }
  function postLike(e) {
    return Promise.all([getToken(), signals()]).then(function (r) {
      return fetchJSON(API + '/v1/like', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code: e.code, voterId: VID.id, token: r[0], fp: r[1][0], pm: r[1][1], vidAge: Math.max(0, Math.round((Date.now() - VID.created) / 1000)) })
      });
    });
  }
  // 送信キュー: 1件ずつ順番に送る
  var queue = [], sending = false;
  function enqueue(job) { queue.push(job); pump(); }
  function pump() {
    if (sending || !queue.length) return;
    sending = true;
    var job = queue.shift();
    var next = function () { sending = false; pump(); };
    postLike(job.e).then(function (res) { settle(job, res); }, function () { settle(job, null); }).then(next, next);
  }
  function settle(job, res) {
    var e = job.e, s = res && res.status, b = (res && res.body) || {};
    e.wait = false;
    if (s === 200 || s === 409) { // 409 = 今日はもう応援済み（サーバー側）。どちらも押した状態のまま
      if (typeof b.likes === 'number') e.likes = e.sent = b.likes;
      updateCounts(e.id);
      return;
    }
    // 失敗: 楽観表示を戻す。今日の応援済みにもしない（すぐ押し直せる）
    e.likes = Math.max(0, e.likes - 1);
    if (job.prev == null) delete store.dates[e.id]; else store.dates[e.id] = job.prev;
    save();
    updateCounts(e.id);
    updateToday();
    var msg = s === 429 ? MSG_CAP : (s === 403 && b.error === 'closed') ? MSG_CLOSED : MSG_FAIL;
    toast(msg);
    if (q(document, '.hx-modal.is-open')) announce(msg); // モーダルの外の読み上げは届かないことがある
  }

  /* 集計の取得（読み込み時に1回） */
  function applyCounts(d) {
    var likes = (d && d.likes) || {};
    var r = d && d.rank;
    RANK = r && r.cur ? r : null;
    // 決済済みの集計になったら、ランキングの見出し・注記を切り替える
    document.documentElement.classList.toggle('pb5-paid-rank', paidRank());
    ENTRIES.forEach(function (e) {
      var n = +likes[e.code] || 0;
      if (e.sent > n) n = e.sent;     // 送信結果より古い数で戻さない
      e.likes = n + (e.wait ? 1 : 0); // 送信待ちの楽観 +1 は残す
      var c = (RANK && RANK.cur[e.code]) || {};
      var p = RANK && RANK.prev ? RANK.prev[e.code] || {} : c;
      // 予約数は足数（qty）で数える（2026-10-15 決定。応援方法の「販売足数が同率の場合」に合わせる）
      e.snap = { orders: +c.qty || 0, likes: +c.likes || 0 };
      e.prev = { orders: +p.qty || 0, likes: +p.likes || 0 };
      updateCounts(e.id);
    });
    calcFinal();
    if (phase === 'final') renderEntries();
    else if (dailyReady()) reorderEntries();
    renderRanking(true);
  }
  function initApi() {
    VID = voter();
    toastBox = document.createElement('div'); // 読み上げを確実にするため、空の枠を先に置いておく
    toastBox.className = 'hx-toast';
    toastBox.setAttribute('role', 'status');
    toastBox.setAttribute('aria-live', 'polite');
    toastBox.addEventListener('click', function (ev) { if (ev.target.closest('[data-toast-close]')) toastHide(); });
    document.body.appendChild(toastBox);
    if (TS_KEY) {
      tsBox = document.createElement('div');
      tsBox.className = 'hx-ts';
      tsBox.innerHTML = '<p class="hx-ts__cap">応援を送る前に、確認をお願いします</p><div class="hx-ts__w"></div>';
      document.body.appendChild(tsBox);
    }
    fetchJSON(API + '/v1/counts').then(function (res) { if (res.status === 200) applyCounts(res.body); }, noop);
    // Turnstile とシグナルはページの読み込み後に準備（表示を邪魔しない）
    var warm = function () { signals(); if (TS_KEY) tsLoad().then(null, noop); };
    if (document.readyState === 'complete') setTimeout(warm, 0); else window.addEventListener('load', warm);
  }

  /* ------------------------------------------------------------
     init
     ------------------------------------------------------------ */
  if (API) initApi();
  applyPhaseLabels();
  renderEntries();
  renderRanking(false);
  renderTicker();
  initSpy();
  initKvParallax();
  initTilt();
  onMQ(mqFine, function (e) { if (e.matches) initKvParallax(); });
  onMQ(mqTilt, function (e) { if (e.matches) initTilt(); });

  var deep = /[?&]e=(E\d+)/.exec(Q);
  if (deep && byId(deep[1])) setTimeout(function () { openEntry(deep[1]); }, 400);
  } catch (err) {
    root.classList.remove('hx-js'); // 初期化に失敗しても白紙にしない
    if (window.console && console.error) console.error(err);
  }
})();
